import * as firebaseDb from '@mlc/firebase-config';

export const environment = {
  production: false,
  uat: false,
  demo: false,
  db: firebaseDb.dev,
  useEmulators: false,
};
